import { render, staticRenderFns } from "./NotesFiles.vue?vue&type=template&id=8704f89c"
import script from "./NotesFiles.vue?vue&type=script&lang=js"
export * from "./NotesFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports